import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=1ed6ef66&scoped=true"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"
import style0 from "./PackageCard.vue?vue&type=style&index=0&id=1ed6ef66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6ef66",
  null
  
)

export default component.exports